import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./StatusIconLive.style";
const StatusIconLive = () => _jsx(S.LiveIndicator, {});
export default StatusIconLive;
export * as Styles from "./StatusIconLive.style";